import { useAppSelector } from "@/store/hooks";
import { fetchShops } from "@/store/slices/shopSlice";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getShopList } from "@/api/planner";
import { useDispatch } from "react-redux";

export default function RequireAuth() {
  const location = useLocation();
  const dispatch = useDispatch()
  const { isAuthenticated, isInitialized } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchShops());
  }, []);
  if (!isInitialized) {
    return <div>로딩중...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}